module.exports = __webpack_public_path__ + "media/images/lb/737-d92ae79dfde646717a9c6ab6239f6945.svg";